module.exports = __webpack_public_path__ + "static/media/nrJd2ub6Ix.e2a959d3.jpg";